import React from 'react'
import { Col, Label, Row } from 'react-bootstrap'
import ReactSwitch from 'react-switch'

function SwitchWithLabel({ checked, handleChecked, width, onChange, color, label, height }) {
  return (
    <Row className="d-flex align-items-center">
      <Col md={9} className="align-items-center">
        <Label>{label}</Label>
      </Col>
      <Col md={3}>
        <ReactSwitch
          checked={checked}
          width={width}
          height={height}
          onChange={onChange}
          onColor={color || '#00cfc3'}
        />
      </Col>
    </Row>
  )
}

export default SwitchWithLabel



// WEBPACK FOOTER //
// ./src/component/Checkbox/SwitchWithLabel.js